import React from "react";
import { styled } from "@mui/material/styles";
import { DataGrid } from "@mui/x-data-grid";

const BootstrapDataGrid = styled(DataGrid)(({ theme }) => ({
  " & .MuiDataGrid-columnHeaders ": {
    backgroundColor: " #999999",
  },
  " & .MuiDataGrid-columnHeaderTitle ": {
    fontWeight: "bold",
    whiteSpace: "normal",
    lineHeight: "normal",
  },
  "& .MuiDataGrid-row:nth-of-type(even)": {
    backgroundColor: "#CCCCCC",
  },
  "& .MuiDataGrid-row:hover": {
    backgroundColor: "#7a7a7a",
  },
  "& .MuiDataGrid-footerContainer": {
    display: "none",
  },
}));

function StyledDataGrid({ rows, columns, ...props }) {
  return <BootstrapDataGrid rows={rows} columns={columns} {...props} />;
}

export default StyledDataGrid;
